<template>
  <div class="google-rating-badge mb-3">
    <div class="google-rating-badge__header">
      <img
        :src="GOOGLE_LOGO_URL"
        alt="Google logo"
        class="google-rating-badge__logo"
      />
      <div class="google-rating-badge__content">
        <span class="google-rating-badge__label">Google Rating</span>
        <div class="google-rating-badge__body">
          <span class="google-rating-badge__rating">{{ rating }}</span>
          <profile-stars :score="rating" />
        </div>
        <a
          href="#reviews-section"
          class="google-rating-badge__link"
          @click.prevent="scrollToReviews"
        >
          See all our reviews
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileStars from './stars.vue';

const GOOGLE_LOGO_URL = 'https://assets.kinside.com/static/web/google-logo.png';

export default {
  name: 'google-rating-badge',

  components: {
    ProfileStars,
  },

  props: {
    rating: {
      type: Number,
      required: true,
    },
    reviewCount: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      GOOGLE_LOGO_URL,
    };
  },

  methods: {
    scrollToReviews() {
      const el = document.getElementById('reviews-section');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.google-rating-badge {
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  margin-top: 16px;

  &__header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  &__logo {
    width: 76px;
    height: 92px;
    flex-shrink: 0;
    padding: 16px 8px;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__label {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }

  &__body {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__rating {
    font-size: 24px;
    font-weight: 700;
    color: #FFB300;
  }

  &__link {
    font-size: 13px;
    color: #5f6368;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
